import React from "react"
import DataTypeHelper from "./DataTypeHelper"

class OwnerDataType extends React.Component{

  render() {
    if (this.props.data) {
      return (
        <a href="#" data-toggle="popover" data-content={DataTypeHelper.renderPopoverMenu(this.props.data)}>{this.props.data.full_name}</a>
      );
    } else {
      return (
        <div>&nbsp;</div>
      );
    }
  }

};

export default OwnerDataType